import { List } from 'immutable';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as commonSelectors from 'containers/Common/selectors';
import * as Models from 'models';

export function useBrandFontsForRelation(
  relationId: string,
): Models.BrandFontsList {
  const flatFonts = useSelector(commonSelectors.flatFontsByRelationId);

  return useMemo(
    (): Models.BrandFontsList => flatFonts.get(relationId) ?? List([]),
    [relationId, flatFonts],
  );
}
